import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const NOTE_TYPE_CONFIG = {
  remediation: { icon: '🔧', color: '#3b82f6', label: 'Remediation Submitted' },
  retest: { icon: '🔍', color: '#8b5cf6', label: 'Retest Result' },
  acceptance: { icon: '✓', color: '#f59e0b', label: 'Risk Accepted' },
};

export default function RemediationTimeline({ findingId }) {
  const { apiFetch } = useAuth();
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!findingId) return;
    (async () => {
      try {
        const res = await apiFetch(`/findings/${findingId}/remediation-timeline`);
        if (res.ok) setNotes(await res.json());
      } catch {}
      setLoading(false);
    })();
  }, [findingId, apiFetch]);

  if (loading) return <div style={{ fontSize: 12, color: 'var(--text-muted)', padding: 8 }}>Loading timeline...</div>;
  if (notes.length === 0) return <div style={{ fontSize: 12, color: 'var(--text-muted)', padding: 8, fontStyle: 'italic' }}>No remediation activity yet.</div>;

  return (
    <div style={{ padding: '8px 0' }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>
        Remediation Timeline
      </div>
      {notes.map((note, i) => {
        const config = NOTE_TYPE_CONFIG[note.note_type] || NOTE_TYPE_CONFIG.remediation;
        const statusChanged = note.old_status && note.new_status && note.old_status !== note.new_status;
        return (
          <div key={note.id} style={{ display: 'flex', gap: 10, marginBottom: i < notes.length - 1 ? 0 : 0 }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
              <div style={{
                width: 28, height: 28, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: config.color + '18', fontSize: 14,
              }}>
                {config.icon}
              </div>
              {i < notes.length - 1 && <div style={{ width: 1, flex: 1, minHeight: 16, background: 'var(--border)' }} />}
            </div>
            <div style={{ flex: 1, paddingBottom: i < notes.length - 1 ? 12 : 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                <span style={{ fontSize: 12, fontWeight: 600, color: config.color }}>{config.label}</span>
                <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>
                  {new Date(note.created_at).toLocaleDateString()}{' '}
                  {new Date(note.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </span>
              </div>
              <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 4 }}>
                <strong>{note.author_name || 'System'}</strong>
                {statusChanged && (
                  <span style={{ marginLeft: 6, fontSize: 11, color: 'var(--text-muted)' }}>
                    {note.old_status} → {note.new_status}
                  </span>
                )}
              </div>
              <div style={{
                fontSize: 13, color: 'var(--text)', whiteSpace: 'pre-wrap',
                padding: '8px 12px', background: 'var(--bg-input)', borderRadius: 6,
                border: '1px solid var(--border)',
              }}>
                {note.content}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
